import { render, staticRenderFns } from "./UspList.vue?vue&type=template&id=5472a21e&scoped=true&"
import script from "./UspList.vue?vue&type=script&lang=js&"
export * from "./UspList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5472a21e",
  null
  
)

export default component.exports